import common from "../common";
import Scene from "./Scene";
import CharacterSelection from "../reusableModules/CharacterSelection";
import Dorothy from "../actors/Dorothy";
import ParticleEmitter from "../reusableModules/ParticleEmitter";
import SecondaryCharacter from "../actors/SecondaryCharacter";

export default class CharacterRequestScene extends Scene {
    constructor() {
        super();
        this._continueButton = null;
        this._muteButton = null;
        this._homeButton = null;
        this._characterSelection = null;
        this._recipeSprite = null;
        this._dorothy = null;
        this._particleEmitter = null;
    }

    init() {
        super.init();

        let bk = new PIXI.Sprite(P3.assets.texture('bg_intro'));
        bk.width = 1900;
        bk.anchor.set(0.5);
        bk.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(bk);

        this.makeRecipeSelection();
        this.makeCharacterSelection();
        this.makeRequestSprites();
        this.addCharacters();
        this.createButtons();
        this.createParticleEmitter();
    }

    destroy() {
        if(this._particleEmitter)
            this._particleEmitter.destroy();

        // clean up goes here
        super.destroy();
    }

    resize() {
        super.resize();

        this._continueButton.x = (common.STAGE_WIDTH + P3.View.width) * 0.5 - 150;
        this._continueButton.y = common.STAGE_HEIGHT * 0.5 + 225;

        this._muteButton.x = (common.STAGE_WIDTH + P3.View.width) * 0.5 - 150;
        this._muteButton.y = (common.STAGE_HEIGHT - P3.View.height) * 0.5 + 100;

        this._homeButton.x = (common.STAGE_WIDTH - P3.View.width) * 0.5 + 150;
        this._homeButton.y = (common.STAGE_HEIGHT - P3.View.height) * 0.5 + 100;
    }

    animateButtons() {
        let newTween = (button, easing)=>{
            return new P3.utils.TWEEN.Tween(button.scale, this.tweens)
                .to({
                    x: 1,
                    y: 1
                }, 340)
                .easing(easing)
                .yoyo(false)
                .delay(200)
                .onStart(() => {
                    button.visible = true;
                });
        };

        this._continueButton.scale.set(0);
        let continueTween = newTween(this._continueButton, P3.utils.Easing.Back3.Out);

        this._muteButton.scale.set(0);
        let muteTween = newTween(this._muteButton, P3.utils.Easing.Back2.Out);

        this._homeButton.scale.set(0);
        let homeTween = newTween(this._homeButton, P3.utils.Easing.Back2.Out);

        homeTween.start();
        muteTween.start();
        continueTween.start();
    }

    update() {
        super.update();

        this._dorothy.update(P3.Ticker.dt);
        if(this._particleEmitter)
            this._particleEmitter.update();
    }

    createButtons(){
        let newButton = (stateTextures)=>{
            let states = new P3.ButtonStates();
            states.normal = P3.assets.texture(stateTextures.normal);
            states.over = P3.assets.texture(stateTextures.over);
            states.down = P3.assets.texture(stateTextures.down);
            states.icon = P3.assets.texture(stateTextures.icon);

            let button = new P3.Button(states);
            button.visible = false;
            this.addChild(button);
            return button;
        };

        this._continueButton = newButton({
            normal:"btn_primary_large_off",
            over:"btn_primary_large_over",
            down:"btn_primary_large_down",
            icon:"icon_play_large_off"
        });
        this._continueSignal = this._continueButton.signals.click.add(this.slideOutDorothy, this);

        this._homeButton = newButton({
            normal:"btn_primary_small_off",
            over:"btn_primary_small_over",
            down:"btn_primary_small_down",
            icon:"icon_home_off"
        });
        this._homeButton.signals.click.add(this.onHomeButtonClick, this);

        //MUTE BUTTON
        let states = new P3.ButtonStates();
        states.normal = P3.assets.texture("btn_primary_small_off");
        states.over = P3.assets.texture("btn_primary_small_over");
        states.down = P3.assets.texture("btn_primary_small_down");
        states.icon = P3.assets.texture("icon_sound_off");
        states.iconAlt = P3.assets.texture("icon_mute_off");

        this._muteButton = new P3.MuteButton(states);
        this._muteButton.visible = false;
        this.addChild(this._muteButton);
    }

    makeRequestSprites() {
        let request = common.selectedCharacter.getRequest();

        this._bubble = new PIXI.Sprite(P3.assets.texture('request'));
        this._bubble.anchor.set(0.5);
        this._bubble.scale.set(0, 0);
        this._bubble.visible = false;
        this._bubble.x = common.STAGE_WIDTH * 0.5;
        this._bubble.y = common.STAGE_HEIGHT * 0.5 - 150;
        this.addChild(this._bubble);

        let recipeSprite = new PIXI.Sprite(P3.assets.texture(request.requestTexture));
        recipeSprite.anchor.set(0.5);
        let ratio = recipeSprite.width / recipeSprite.height;
        recipeSprite.width = 246;
        recipeSprite.height = 246 / ratio;
        recipeSprite.position.set(10, -10);
        this._bubble.addChild(recipeSprite);

        if(request.wants === false){
            let cross = new PIXI.Sprite(P3.assets.texture('request_not'));
            cross.anchor.set(0.5);
            cross.position.set(10, -10);
            this._bubble.addChild(cross);
        }
    }

    makeCharacterSelection() {
        this._characterSelection = new CharacterSelection();
    }

    makeRecipeSelection() {
        let recipes = P3.assets.json('RecipeData');
        common.selectedRecipe = common.randomSelection(recipes.Recipes);

        for(let i = 0; i < recipes.Builds.length; i++) {
            if (recipes.Builds[i].type === common.selectedRecipe.type) {
                common.selectedRecipeBuild = recipes.Builds[i];
            }
        }
    }

    addCharacters(){
        this._secondaryCharacter = new PIXI.Sprite(common.selectedCharacter._charTexture);
        this._secondaryCharacter.anchor.set(0.5);
        this._secondaryCharacter.scale.set(1.1);
        this._secondaryCharacter.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5 - this._secondaryCharacter.width, common.STAGE_HEIGHT * 0.5 + this.getCharacterPosition());
        //this._secondaryCharacter.position.set(common.STAGE_WIDTH * 0.5 - 1000, common.STAGE_HEIGHT * 0.5 + this.getCharacterPosition());
        this.addChild(this._secondaryCharacter);
        this.animateSecondaryCharacter();

        this._dorothy = new Dorothy();
       // this._dorothy.position.set(common.STAGE_WIDTH * 0.5 + 900, common.STAGE_HEIGHT * 0.5 + 325);
        this._dorothy.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 + 300, common.STAGE_HEIGHT * 0.5 + 325);
        this._dorothy.scale.set(0.85);
        this.addChild(this._dorothy);

        let onStartIn = ()=>{
            this._dorothy.playJumpInAnimation();
            P3.audio.playSound("sfx_dorothy_jump_in_00");
        };
        let onCompleteIn = ()=>{
            P3.audio.playSound("sfx_character_request_00");
        };
        this._dorothy.slideInDorothy(this.tweens, common.STAGE_WIDTH * 0.5 + 300, onStartIn, onCompleteIn).start();

        let onStartOut = ()=>{
            this._dorothy.playJumpOutAnimation();
        };
        let onCompleteOut = ()=>{
            this.onContinueButtonClick();
        };
        // this._dorothy._slideOutTween = this._dorothy.slideInDorothy(
        //     this.tweens,
        //     common.STAGE_WIDTH * 0.5 + 900,
        //     onStartOut,
        //     onCompleteOut);
        this._dorothy._slideOutTween = this._dorothy.slideInDorothy(
            this.tweens,
            (common.STAGE_WIDTH + P3.View.width) * 0.5 + 300,
            onStartOut,
            onCompleteOut);
    }

    slideOutDorothy(){
        this._continueSignal.detach();
        this._dorothy._slideOutTween.start();
        P3.audio.playSound("sfx_btn_accept_00");
    }

    animateSecondaryCharacter(){
        let breath = SecondaryCharacter.BREATH(this.tweens, this._secondaryCharacter);
        let breathIn = breath.in;
        let slideIn = SecondaryCharacter.SLIDE_IN(this.tweens, this._secondaryCharacter._slideInAmount, this._secondaryCharacter);

        let bubbleTween = new P3.utils.TWEEN.Tween(this._bubble.scale, this.tweens)
            .to({
                x: 0.8,
                y: 0.8
            }, 750)
            .onStart(()=>{
                this._bubble.visible = true;
            })
            .onComplete(()=>{
                if(this._particleEmitter)
                    this._particleEmitter.play();
                this._dorothy.playHappAnimation(1);
                this.animateButtons();
                P3.audio.playSound('sfx_stage_complete_00');
            })
            .easing(P3.utils.Easing.Back2.Out);

        slideIn.chain(breathIn, bubbleTween);
        slideIn.delay(2000);
        slideIn.start();
    }

    createParticleEmitter(){
        let particles = ParticleEmitter.LOVE_HEARTS;

        this._particleEmitter = new ParticleEmitter(particles, ParticleEmitter.HEARTS, false);
        let config = this._particleEmitter._config;
        config.scale = {
            "start": 0.4,
            "end": 1.6,
            "minimumScaleMultiplier": 1.4
        };
        this._particleEmitter.overrideDefaultConfig(config);

        this._particleEmitter.position.set(0, 50);
        this._bubble.addChild(this._particleEmitter);
        this._particleEmitter.enableLoop();
        this._particleEmitter.scale.set(0.8)
    }

    getCharacterPosition(){
        switch (common.selectedCharacter.getName()) {
            case "Tin Man":
                this._secondaryCharacter._slideInAmount = common.STAGE_WIDTH * 0.5 - 350;
                this._secondaryCharacter.scale.set(1.15);
                return 175;
            case "Lion":
                this._secondaryCharacter._slideInAmount = common.STAGE_WIDTH * 0.5 - 380;
                return 150;
            case "Scarecrow":
                this._secondaryCharacter._slideInAmount = common.STAGE_WIDTH * 0.5 - 350;
                this._secondaryCharacter.scale.set(1.2);
                return 175;
            case "Ozma":
                this._secondaryCharacter._slideInAmount = common.STAGE_WIDTH * 0.5 - 350;
                return 175;
        }
    }

    //=========================
    //BUTTON CLICKS
    //=========================
    onHomeButtonClick() {
        this.signals.previous.dispatch();
        P3.audio.playSound("sfx_btn_accept_00");
    }

    onContinueButtonClick() {
        this.signals.next.dispatch();
    }
}